var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9377_79332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0H24.75V24H0.75V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0H8.75156V24H0.75V0Z",
    fill: "#000091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.748 0H24.7496V24H16.748V0Z",
    fill: "#E1000F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9377_79332"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFr);
export default __webpack_public_path__ + "static/media/fr.6b93ac94df8852800e97c1373c7089c4.svg";
export { ForwardRef as ReactComponent };